import React, { useEffect, useRef, useState } from "react";
import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import Lelo from "./logo-lelotrip.png";
import "./Navbars.css";
import {
  FaCrown,
  FaEnvelope,
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaRegUser,
  FaUserAlt,
  FaUserCircle,
  FaPlane,
  FaChevronDown,
} from "react-icons/fa";
import { IoMdGlobe, IoMdLogIn, IoMdNotificationsOutline } from "react-icons/io";
import {
  MdChatBubbleOutline,
  MdEmail,
  MdLogout,
  MdWhatsapp,
} from "react-icons/md";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SignUp from "./SignUp";
import { HiOutlineMenuAlt2 } from "react-icons/hi";

import ProtectedLink from "../ProtectedLink";
import { useAuth } from "../../context/AuthContext";
import { CountriesArray } from "./Countries";
import { FaPhoneVolume, FaRegCircleUser, FaXTwitter } from "react-icons/fa6";
import { IoPersonCircleOutline, IoTicketOutline } from "react-icons/io5";
import { AiOutlineUser } from "react-icons/ai";
import { RiMenu2Line, RiWallet3Line } from "react-icons/ri";
import { BsBoxArrowInRight } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { loggedOut } from "../../redux/slices/login";
import SideBar from "./SideBar";
// import { useAuth } from "../../context/AuthContext";

import { FaDollarSign,} from "react-icons/fa";
import CurrencyPopup from "./CurrencyPopup";

import ReactCountryFlag from "react-country-flag";
import GoogleTranslator from "./GoogleTranslator";


const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
};
const Navbars = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState(false);
  const [show, setShow] = useState(false);
  const isAuth = useSelector((state) => state.authenticate.isAuth);
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [names, setNames] = useState("");
useEffect(() => {
  setEmail(localStorage.getItem("email"));
  setNames(localStorage.getItem("names"));
}, [isAuth]);
  const handleAuthClick = () => {
    if (isAuth) {
      dispatch(loggedOut());
    } else {
      handleShow();
      setExpanded(false);
      setShowSideNav(false);
    }
  };

  const [otpSent, setOtpSent] = useState(false);
  const handleClose = () => {
    setShow(false);
    // setOtpSent(false)
  };
  const handleShow = () => setShow(true);

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    setExpanded(false);
  };
  const [expanded, setExpanded] = useState(false);
  const [showSideNav, setShowSideNav] = useState(false);
  const [isOpen, setIsOpen] = useState(false); // For dropdown
  const [selectedCountry, setSelectedCountry] = useState({
    code: "in",
    name: "India",
  });

  const width = useWindowWidth();

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsOpen(false);
  };

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleToggle = () => {
    const isPhone = width <= 998;
    if (isPhone) {
      setShowSideNav(true); // Show custom side nav
      setExpanded(false); // Make sure collapse nav stays closed
    } else {
      setExpanded(expanded ? false : "expanded"); // Toggle Bootstrap collapse on desktop
      setShowSideNav(false); // Just in case it's open, hide it
    }
  };

  const [showHelpDropdown, setShowHelpDropdown] = useState(false);
  const [showCurrencyPopup, setShowCurrencyPopup] = useState(false);


  const toggleHelpDropdown = () => {
    setShowHelpDropdown((prev) => !prev);
  };
  const [showMore, setShowMore] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);

  const handleMouseEnter = () => setShowDropdown(true);
  const handleMouseLeave = () => setShowDropdown(false);

  const [showSupport, setShowSupport] = useState(false);
  const handleMyAccount = () => {
    navigate("/bookings/flight");
    setShowSideNav(false);
  };
  const handleSupport = () => {
    navigate("/contact");
    setShowSideNav(false);
  };
  const handleLoginClick = () => {
    handleShow();
    setExpanded(false);
    setShowSideNav(false);
  };
  const handleLoginFunc = () => {
    setShowSideNav(false);
    setShow(true);
  };

  const location = useLocation();
  // const isHome = location.pathname === "/";
  const isHome =
    location.pathname === "/" ||
    location.pathname === "/hotel" ||
    location.pathname === "/tour";

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const [isClosing, setIsClosing] = useState(false);

  // const handleAccountClick = () => {
  //   setIsSidebarOpen(true);

  //   // For WebView communication (optional)
  //   if (window.ReactNativeWebView) {
  //     window.ReactNativeWebView.postMessage("openSidebar");
  //   }
  // };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsSidebarOpen(false);
    }
  };
  const handleAccountClick = () => {
    setIsSidebarOpen(true);
    setIsClosing(false);
  };

  const handleCloseSidebar = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsSidebarOpen(false);
    }, 300); // Must match the CSS transition time
  };

  useEffect(() => {
    if (isSidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen]);

  return (
    <div className="main-nav">
      <div
        id="opct3"
        className="_opcMenu"
        style={{ display: showSideNav ? "block" : "none" }}
      ></div>
      <Navbar
        // bg="#053355"
        expand="lg"
        // className="p-0"
        collapseOnSelect
        expanded={expanded}
        className={`p-0 ${isHome ? "navbar-home_sky" : "navbar-other_sky"}`}
        style={{
        border: "none",
        background: isHome
          ? "linear-gradient(180deg, rgba(0, 0, 0, .52), transparent)"
          : "#053355",
      }}
        // style={{
        //   border: "none",
        //   background:
        //     "linear-gradient(180deg, rgba(0, 0, 0, .52), transparent)",
        // }}
      >
        <div className="nav_container">
          <Navbar.Toggle onClick={handleToggle}>
            <HiOutlineMenuAlt2 size={24} />
          </Navbar.Toggle>
          <div
            id="mySidenav_v3"
            className="_sidenav"
            style={{ width: "75%", display: showSideNav ? "block" : "none" }}
          >
            <div className="">
              <Link
                className="closemenu_v3"
                onClick={(e) => {
                  e.preventDefault();
                  setShowSideNav(false);
                }}
              >
                ×
              </Link>

              <div
                id="divSignInPnl"
                className="divSignInPnl"
                onClick={handleAuthClick}
              >
                <div
                  className="_menuProf menu_top_Tg menu_trip_go_card"
                  style={{ gap: "15px", alignItems: "center", border: "none" }}
                >
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "50px",
                      padding: "5px",
                    }}
                  >
                    <AiOutlineUser size={35} color="#053355" />
                  </div>
                  {isAuth ? (
                    <div className="_logRt">
                      <div className="_logSinup"> Hi {names}</div>
                      <div className="_logDt"> {email}</div>
                    </div>
                  ) : (
                    <div className="_logRt">
                      <div className="_logSinup">Login or Signup</div>
                      <div className="_logDt"> and Grab Exclusive deals</div>
                    </div>
                  )}
                </div>
              </div>

              <div
                style={{
                  width: "90%",
                  margin: "auto",
                }}
              >
                <div
                  className="_menuProf"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="inner_account_nav" onClick={handleMyAccount}>
                    <div className="inner_acc">
                      <FaRegUser color="#fff" size={20} />
                    </div>
                    <p>My Account</p>
                  </div>

                  <div className="inner_account_nav">
                    <div className="inner_acc">
                      <MdChatBubbleOutline color="#fff" size={20} />
                    </div>
                    <p className="">Notifications</p>
                  </div>
                  <div className="inner_account_nav" onClick={handleSupport}>
                    <div className="inner_acc">
                      <IoMdNotificationsOutline color="#fff" size={20} />
                    </div>
                    <p>Support</p>
                  </div>
                </div>
              </div>
              <div className="_sidMenu">
                <div className="_sidMenu_tggg" onClick={handleMyAccount}>
                  <Link>
                    <div className="_bxIcn">
                      <div className="_menuIcn">
                        <IoTicketOutline color="#053355" size={25} />
                      </div>
                      <div className="_logRgt">
                        <div className="_hTxt"> My Booking</div>
                        <p className="_mTxt">
                          {" "}
                          View and manage your <br />
                          bookings
                        </p>
                      </div>
                    </div>
                    <i
                      className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                    />
                  </Link>
                </div>

                <div className="_sidMenu_tggg">
                  <Link>
                    <div className="_bxIcn">
                      <div className="_menuIcn">
                        <RiWallet3Line color="#053355" size={25} />
                      </div>
                      <div className="_logRgt">
                        <div className="_hTxt">VolarProWallet</div>
                        <p className="_mTxt">
                          {" "}
                          Use your wallet for hassle- <br />
                          free booking
                        </p>
                      </div>
                    </div>
                    <i
                      className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                    />
                  </Link>
                </div>
              </div>

              <div className="_sidMenu" style={{ marginTop: "10px" }}>
                <div className="_sidMenu_tggg">
                  <Link
                    to="https://instagram.com"
                    target="_blank"
                  >
                    <div className="_bxIcn">
                      <div className="_menuIcn">
                        {/* Instagram Gradient or closest solid color */}
                        <FaInstagram color="#E4405F" size={25} />
                      </div>
                      <div className="_logRgt">
                        <div className="_hTxt">Instagram</div>
                      </div>
                    </div>
                    <i
                      className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                    />
                  </Link>
                </div>

                <div className="_sidMenu_tggg">
                  <Link
                    to="https://www.facebook.com"
                    target="_blank"
                  >
                    <div className="_bxIcn">
                      <div className="_menuIcn">
                        {/* Facebook Blue */}
                        <FaFacebookSquare color="#1877F2" size={25} />
                      </div>
                      <div className="_logRgt">
                        <div className="_hTxt">Facebook</div>
                      </div>
                    </div>
                    <i
                      className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                    />
                  </Link>
                </div>

                <div className="_sidMenu_tggg ">
                  <Link to="https://twitter.com" target="_blank">
                    <div className="_bxIcn">
                      <div className="_menuIcn">
                        {/* X (Twitter) Black */}
                        <FaXTwitter color="#000000" size={25} />
                      </div>
                      <div className="_logRgt">
                        <div className="_hTxt">Twitter</div>
                      </div>
                    </div>
                    <i
                      className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                    />
                  </Link>
                </div>
              </div>

              <div className="_sidMenu">
                <Link>
                  <div className="_bxIcn" onClick={toggleHelpDropdown}>
                    <div className="_menuIcn" style={{ marginTop: "7px" }}>
                      <i
                        className="_yourBoking"
                        style={{
                          background:
                            "url('https://images.emtcontent.com/flag/flag_IN.svg')",
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                        }}
                      />
                    </div>
                    <div className="_logRgt">
                      <p className="_mTxt">Country / Region</p>
                      <div className="_hTxt">India</div>
                    </div>
                  </div>
                  <i
                    className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                  />
                </Link>
              </div>
              <div className="_sidMenu">
                <Link onClick={handleAuthClick}>
                  <div className="_bxIcn" onClick={toggleHelpDropdown}>
                    <div className="_menuIcn" style={{ marginTop: "7px" }}>
                      <BsBoxArrowInRight size={25} color="#aa0000" />
                    </div>
                    <div className="_logRgt">
                      <div className="_hTxt" style={{ color: "#aa0000" }}>
                        {isAuth ? "Sign Out" : "Login"}
                      </div>
                    </div>
                  </div>
                  <i
                    className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                  />
                </Link>
              </div>

              <div className="_sidMenu tLogout" style={{ display: "none" }}>
                <Link>
                  <div className="_bxIcn">
                    <div className="_menuIcn">
                      <i className="_logOut" />
                    </div>
                    <div className="_logRgt">
                      <div className="_hTxt">
                        {" "}
                        {isAuth ? "Sign Out" : "Login"}
                      </div>
                    </div>
                  </div>
                  <i className="_arwwLft" />
                </Link>
              </div>
            </div>

            <link id="linkb2bMenu" href="" rel="stylesheet" />

            <div className="bg_ovrly" style={{ display: "none" }} />
          </div>

          <Navbar.Collapse
            id="navbarCollapse"
            style={{
              order: expanded && "4",
              paddingBottom: expanded && "10px",
              // marginTop: "20px",
            }}
          >
            <Nav className="me-auto py-4 py-lg-0">

            </Nav>


            <div className="header-right-sec">


              <div className="nav-item helpMenu">
                {/* <Link className="navigation-link-new" type="link" to="/contact">
                  Support
                </Link> */}
                <Nav
                  className="ml-auto support_link"
                  onMouseLeave={handleMouseLeave}
                >
				<div style={{ marginRight: "10px" }}>
    <GoogleTranslator />
  </div>
                <Nav.Link
                  className="navigation-link-new"
                 
                >
                  LANG :   <ReactCountryFlag
                    countryCode="US"
                    svg
                  />
                  {/* <FaDollarSign /> */} -
                  USD
                </Nav.Link>


      { /*  {showCurrencyPopup && (
        <CurrencyPopup onClose={() => setShowCurrencyPopup(false)} />
      )} */ }


  <Nav.Link
    as={Link}
    to="/login"
    className="navigation-link-new"
    // style={{ color: "#000", alignItems: "center", fontWeight: 600, fontSize: "14.4px" }}
  >
    <FaPlane /> My Trip
  </Nav.Link>

  <NavDropdown
    title={
      <span
        className="navigation-link-new"
        style={{
          alignItems: "center",
          color: "#000",
          fontWeight: 600,
          fontSize: "14.4px",
        }}
      >
        <FaUserCircle style={{ marginRight: "6px" }} /> Support
      </span>
    }
    id="navbarDropdown"
    className="no-border support_link"
    style={{ padding: 0 }}
    show={showDropdown}
    onMouseEnter={handleMouseEnter}
  >

<NavDropdown.Item href="mailto:support@volarpro.com">
  <div className="cus_icon">
    <FaUserCircle className="icon" />
  </div>

  <div className="cus_txt">
    <span className="title">Account Manager</span>
    <span className="sub_txt">
      +966 58 085 8030 <br />
      support@volarpro.com
    </span>
  </div>
</NavDropdown.Item>

<NavDropdown.Item
  onClick={() => window.location.href = "mailto:support@volarpro.com"}
>
  <div className="cus_icon">
    <IoMdGlobe className="icon" />
  </div>

  <div className="cus_txt">
    <span className="title">Customer Support</span>
    <span className="sub_txt">
      support@volarpro.com <br />
      +966 58 085 8030
    </span>
  </div>
</NavDropdown.Item>

<NavDropdown.Item
  href="https://wa.me/966580858030"
  target="_blank"
  rel="noopener noreferrer"
  className="d-flex align-items-center"
>
  <div className="cus_icon whatsapp_icon">
    <MdWhatsapp className="icon" />
  </div>

  <div className="cus_txt">
    <span className="title" style={{ marginTop: "6px" }}>
      +966 58 085 8030
    </span>
  </div>
</NavDropdown.Item>

<NavDropdown.Item>
  <div className="cus_icon">
    <FaEnvelope className="icon" />
  </div>

  <div className="cus_txt">
    <span className="title">For Booking</span>
    <span className="sub_txt">
      <a
        className="mail_link"
        href="mailto:support@volarpro.com?subject=Booking%20Inquiry"
        onClick={(e) => {
          e.stopPropagation();  
          setShowDropdown(false);
        }}
      >
        support@volarpro.com
      </a>
    </span>
  </div>
</NavDropdown.Item>

<NavDropdown.Item>
  <div className="cus_icon">
    <FaEnvelope className="icon" />
  </div>

  <div className="cus_txt">
    <span className="title">For Refund</span>
    <span className="sub_txt">
      <a
        className="mail_link"
        href="mailto:support@volarpro.com?subject=Refund%20Request"
        onClick={(e) => {
          e.stopPropagation();  
          setShowDropdown(false);
        }}
      >
        support@volarpro.com
      </a>
    </span>
  </div>
</NavDropdown.Item>
  </NavDropdown>

                </Nav>
              </div>
              <button className="btn-signin css-79xub" type="button">
                <span className="icon_grey">
                  <svg
                    viewBox="0 0 18 18"
                    className="sv svg-1-25 text-gray-700  "
                    aria-hidden="true"
                  >
                    <use className="sv-icon" xlinkHref="#sv_user_new_grey" />
                  </svg>
                </span>
                <span className="icon_blue">
                  <IoPersonCircleOutline size={23} />
                </span>
                <span className="text">
                  My Account
                  {/* Sign In <span className="seprator-slash">/</span> Sign Out */}
                </span>
                <span className=" css-w0pj6f" />

                <div className="option-list ">
                  <ul className="first-menu">
				  {!isAuth ? (
                    <li>
                      <Link className="item-link " onClick={handleAuthClick}>
                        <div className="left-sec">
                          {/* <img
                            src="https://cdn-icons-png.freepik.com/512/15804/15804019.png"
                            alt=""
                            style={{ height: "32px", width: "32px" }}
                          /> */}
                          <IoMdLogIn color="#fff" />
                          Login
                        </div>
                      </Link>
                    </li>
					) : (
					<li>
      <Link
        className="item-link"
        onClick={() => {
          dispatch(loggedOut());
          navigate("/");
        }}
      >
        <div className="left-sec">
          <MdLogout color="#fff" />
          Logout
        </div>
      </Link>
    </li>
					 )}
                    { /* <li>
                      <Link className="item-link " to="/hotel">
                        <div className="left-sec">
                          <IoMdLogIn color="#fff" />
                          Register
                        </div>
                      </Link>
</li> */ }

                  </ul>
                </div>
              </button>
            </div>
          </Navbar.Collapse>
          <Navbar.Brand as={Link} to="/">
            <img className="logo-main me-2" src="/Images/volarpro-logo.png" alt="Logo" />
          </Navbar.Brand>

          <div
            className="nav-item moreTravel"
            style={{ marginRight: "25px" }}
            onClick={handleAccountClick}
          >
            <div data-v-37a9e1d3="" className="topnav_menuIcon ripple">
              <RiMenu2Line size="20" className="desk-icon-menu" color="#fff" />{" "}
            </div>
          </div>

          <div
            className="flex flex-middle px-1 singupbtn"
            style={{ marginLeft: "12px" }}
          >
            <div
              className="sharenation"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "7px",
              }}
            >
              <div
                className="_langview b2cpanel dropdown-header"
                onClick={toggleDropdown}
              >
                <span id="spnFlgImgHead">
                  <img
                    src={`https://flagcdn.com/w20/${selectedCountry.code}.png`}
                    alt=""
                  />
                </span>
                <span id="spnCC">{selectedCountry.name}</span>
                <i className={`_arrwdnlang ${isOpen ? "open" : ""}`}></i>
                {isOpen && (
                  <div className="dropdown-options">
                    {CountriesArray.map((country, index) => (
                      <div
                        key={index}
                        className="option"
                        onClick={() => handleCountrySelect(country)}
                      >
                        <img
                          src={`https://flagcdn.com/w20/${country.code}.png`}
                          alt=""
                        />
                        <span>{country.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Navbar>

      <SignUp
        show={show}
        setShow={setShow}
        handleClose={handleClose}
        handleShow={handleShow}
        otpSent={otpSent}
        setOtpSent={setOtpSent}
      />
      {isSidebarOpen && (
        <div
          className={`sidebar option-list ${isClosing ? "close" : "open"}`}
          ref={sidebarRef}
        >
          <button className="close-btn" onClick={handleCloseSidebar} style={{fontSize:"22px",color:'#fff'}}>
            ×
          </button>
          <SideBar  setIsSidebarOpen={ setIsSidebarOpen}/>

        </div>
      )}
    </div>
  );
};

export default Navbars;
